import type { HomeChartBaseline } from "./types-home-chart";

/**
 * Faixa vertical do gráfico.
 *
 * Em `"relevo"` o eixo não parte de zero: a faixa é encostada nos valores da
 * série — com folga maior embaixo do que em cima — para que a variação entre os
 * anos se veja como no protótipo, em vez de virar uma linha quase reta no topo
 * de um eixo dominado pela distância até zero.
 */
export function resolveVerticalScale(
  values: number[],
  baseline: HomeChartBaseline,
): { min: number; max: number } {
  const maior = Math.max(...values, 0);
  if (baseline === "zero") return { min: 0, max: maior * 1.25 };

  const menor = Math.min(...values);
  const amplitude = maior - menor;
  // Uma série constante não tem amplitude para trabalhar: cai no enquadramento
  // pelo próprio valor, que ainda deixa a linha visível no meio do cartão.
  const folga = amplitude || Math.abs(maior) || 1;

  return { min: menor - folga * 0.45, max: maior + folga * 0.25 };
}
